import React, { Component } from 'react';
import { withRouter } from "react-router-dom";

import Firebase from 'firebase';

const dominios = ["gmail", "yahoo", "msn", "hotmail", "outlook", "vtr"]


class step1 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: props.name,
            email: props.email,
            password: props.password,
            re_password: props.re_password
        }
    }

    componentWillUpdate(nextProps, nextState) {
        if (nextState.email !== this.state.email) {
            var email = nextState.email;
            var domain = email.replace(/.*@/, "");
            var compare = domain.split('.');
            var i = 0;
            while (i <= dominios.length) {
                if (compare[0].toLowerCase() === dominios[i]) {
                    this.setState({ val_email: true })
                    i = 1000;
                } else {
                    this.setState({ val_email: false })
                }
                i = i + 1;
            }
        }
        if (nextState.re_password !== this.state.re_password) {
            if (nextState.re_password !== nextState.password) {
                this.setState({ val_password2: true })
            } else {
                this.setState({ val_password2: false })
            }
        }
        if (nextState.name !== this.state.name ||
            nextState.email !== this.state.email ||
            nextState.password !== this.state.password ||
            nextState.re_password !== this.state.re_password) {
            this.props.setValues(nextState.name, nextState.email, nextState.password, nextState.re_password);
        }
    }

    render() {
        return (
            <fieldset>
                <h1>Nuevo Usuario</h1>
                <p className="text-muted">Paso 1</p>
                <br />
                <div className="form-group mb-4">
                    <input className="form-control" type="text" name="Nombre" placeholder="Nombre completo" value={this.state.name} onChange={(e) => {
                        this.setState({ name: e.target.value });

                    }} />
                </div>
                <div className="form-group mb-3">
                    <input className="form-control" style={this.state.val_email ? { borderColor: "red" } : {}} type="text" name="Email" placeholder="Email" value={this.state.email} onChange={(e) => { this.setState({ email: e.target.value }) }} />
                    <small className="form-text text-muted">
                        {this.state.val_email ? "Correo ingresado invalido o no permitido." : "Ingrese su correo institucional"}
                    </small>
                </div>
                <div className="form-group mb-3">
                    <input className="form-control" type="password" name="pass" placeholder="Contraseña" value={this.state.password} onChange={(e) => { this.setState({ password: e.target.value }) }} />
                    <small id="emailHelp" className="form-text text-muted">Ingrese una contraseña mayor a 6 caracteres.</small>
                </div>
                <div className="form-group mb-3">
                    <input type="password" style={this.state.val_password2 ? { borderColor: "red" } : {}} className="form-control is-invalid" id="validationServer03" placeholder="Repita contraseña" required value={this.state.re_password} onChange={(e) => { this.setState({ re_password: e.target.value }) }} />
                    <small id="emailHelp" className="form-text text-muted">{this.state.re_password ? this.state.val_password2 ? "Las contraseñas no coinciden." : "Contraseña correcta" : ""}</small>
                </div>
                <div className="row" style={this.state.re_password ? { position: "relative", bottom: "-80" }: { position: "relative", bottom: "-101" }} >
                    <div className="col-6">
                    </div>
                    <div className="col-6 text-right">
                        {
                            !this.state.val_password2 && !this.state.val_email && this.state.re_password && this.state.name && this.state.email ?
                                <button type="button" className="btn btn-primary" onClick={() => { this.props.callBack(2) }}>Siguiente</button>
                                :
                                <button type="button" className="btn btn-primary" disabled>Siguiente</button>
                        }
                    </div>
                </div>
            </fieldset>
        );
    }
}
export default step1;


// WEBPACK FOOTER //
// ./src/views/register/step1.js